import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { MixpanelScript } from './components/MixpanelScript';
export function App() {
  return <>
      <MixpanelScript data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}